export default __webpack_public_path__ + "static/media/knobs.889d8edc.svg";